export class ExternalSaleTransactionModel {
  transactionSurrkey: string;
  companySurrkey: number;
  companyName: string;
  paymentDate: Date;
  isPayed: boolean;
  companyInfoCompanyCountry: string;
  refTransactionCode: string;
}

export class ExternalSaleTransactionListModel {
  itemList: Array<ExternalSaleTransactionModel>;
  pageNumber: number;
  pageSize: number;
  totalItemCount: number;
  totalPageCount: number;
}

export class ExternalSaleTransactionListQueryModel {
  textSearch?: string;
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortByDesc: boolean;
  status?: number;
  startDate?: Date;
  endDate?: Date;
}
